import { render, staticRenderFns } from "./AmostrasStepIcpRevisao.vue?vue&type=template&id=bf1f8f46&"
import script from "./AmostrasStepIcpRevisao.vue?vue&type=script&lang=ts&"
export * from "./AmostrasStepIcpRevisao.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCheckbox,VDataTable})
